<template>
    <div>
        <div class="text-muted mb-1">
            <em class="fa fa-spinner mr-1"></em>
            <span class="field">
                {{
                    $t('feed.checkin.reach_the_goal', {
                        value: post.artifact.progress * 100 || 0,
                    })
                }}
            </span>
        </div>
        <div class="text-muted mb-1">
            <em class="fa fa-refresh mr-1"></em>
            <span class="field">
                {{ $t('feed.checkin.realized_value') }}:
                {{ post.artifact.value || 2 }}
            </span>
        </div>
        <div class="text-muted mb-1" v-show="post.artifact.satisfaction">
            <span class="field"> {{ $t('checkIn.howAmIFeeling') }}: </span>
            <strong>
                <i
                    :class="['fa fa-lg', smileIconClass(post.artifact.satisfaction)]"
                    :title="$t(smileStatus(post.artifact.satisfaction))"
                ></i>
            </strong>
        </div>
        <div v-if="post.checkin.comments" class="mb-1">
            <span class="field">{{ $t('checkIn.generalComments') }}: </span>
            <div v-html="post.checkin.comments" class="key-result-comment"></div>
        </div>

        <div v-if="post.checkin.difficulties">
            <span class="field">{{ $t('checkIn.difficultiesFound') }}: </span>
            <div v-html="post.checkin.difficulties" class="key-result-comment"></div>
        </div>
    </div>
</template>

<script>
import { smilesClassesMixin } from '@/mixins'

export default {
    name: 'Artifact',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [smilesClassesMixin],
}
</script>

<style scoped>
.key-result-comment ::v-deep p {
    margin: 0;
}
</style>
